import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/docs/fundamentals/FundamentalsPage.tsx");
